export default __webpack_public_path__ + "static/media/export-icon.a7455f25.svg";